import {
  Component,
  OnInit,
  OnDestroy,
  DestroyRef,
  inject,
} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  UntypedFormArray,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { IArticles } from 'src/app/@interfaces/article.interface';
import { ICustomer } from 'src/app/@interfaces/customer.interface';
import { IQuotation } from 'src/app/@interfaces/quotation.interface';
import { IWarehouse } from 'src/app/@interfaces/warehouse.interface';
import { CustomerService } from 'src/app/@pages/customer/customer.service';
import { InventoryService } from 'src/app/@pages/inventory/inventory.service';
import { QuotationsService } from 'src/app/@pages/quotations/quotations.service';
import { WarehouseService } from 'src/app/@pages/warehouse/warehouse.service';
import { ISeller } from 'src/app/@interfaces/seller.interface';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import {
  takeUntil,
  debounceTime,
  distinctUntilChanged,
  filter,
  switchMap,
} from 'rxjs/operators';
import { Subject } from 'rxjs';
import { RegisterSalesService } from './register-sale.service';
import { UsersService } from 'src/app/@pages/users/users.service';
import { IUserSeller } from 'src/app/@interfaces/userSeller.interface';
import { environment } from 'src/environments/environment';
import { CookieAuthService } from 'src/app/@shared/storage-variables/cookie-auth.service';
import { AlertsService } from '../../../services/alerts/alerts.service';
import { ArticleValidationsService } from '../../../services/validations/article-validations.service';
import { UnitConversionService } from 'src/app/@shared/services/unit-conversion.service';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import {
  MatAutocompleteModule,
  MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { InventoryArticleWarningComponent } from '@shared-components';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatSelectModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatButtonModule,
    NgxSpinnerModule,
    CurrencyPipe,
    DecimalPipe,
    TranslatePipe,
    InventoryArticleWarningComponent,
  ],
})
export class RegisterComponent implements OnInit {
  private spinnerService = inject(NgxSpinnerService);
  private customers = inject(CustomerService);
  private article = inject(InventoryService);
  public dialog = inject(MatDialog);
  public quotation = inject(QuotationsService);
  public warehouse = inject(WarehouseService);
  private fb = inject(UntypedFormBuilder);
  private registerSalesService = inject(RegisterSalesService);
  private userS = inject(UsersService);
  private alertsService = inject(AlertsService);
  private cookieAuthService = inject(CookieAuthService);
  private articleValidationsService = inject(ArticleValidationsService);
  private unitConversionService = inject(UnitConversionService);
  private destroyRef = inject(DestroyRef);

  sellerList: Array<IUserSeller> = [];
  sellerCustomer = {} as ISeller;
  dateToday = new Date();
  totalRow: number = 0;
  totalQuot: number = 0;
  taxVer: number = 0;

  newCustomer: UntypedFormControl = this.fb.control('', Validators.required);
  registerForm: UntypedFormGroup = this.fb.group({
    itemRows: this.fb.array([]),
    tax_incl: false,
    tax: [0, [Validators.maxLength(2), Validators.min(0)]],
    date: [this.dateToday, Validators.required],
    dueDate: [this.dateToday, Validators.required],
    seller: ['', [Validators.required]],
    positive_balance: ['0', [Validators.required]],
    observations: [null],
  });

  get rowsArr(): UntypedFormArray {
    return this.registerForm.get('itemRows') as UntypedFormArray;
  }

  CustomersList: Array<ICustomer> = [];
  ArticleList: Array<IArticles> = [];
  WarehouseList: Array<IWarehouse> = [];
  filteredArticles: IArticles[][] = [];

  Quotations = [] as IQuotation[];
  Articles = [] as IArticles[];
  newArticleEmpy = {} as IArticles;
  Customers = [] as ICustomer[];
  companyId = '';
  user = '';
  rol = '';
  userSeller = '';
  currentWarehouse: number = 0;
  showDevelopWarning: boolean = false;

  ngOnInit() {
    this.getAuthValues();

    this.warehouse
      .listWarehouses()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        this.WarehouseList = result;
      });

    this.userS
      .getAllSellerUser()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result: any) => {
        this.sellerList = result;
      });

    this.addNewRow();
    this.setValuesByEnviroment();
    this.initCustomerAutocomplete();
  }

  private initCustomerAutocomplete() {
    if (this.rol === '1' || this.rol === '3') {
      this.newCustomer.valueChanges
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((value: any) => {
          if (!value || !value.__typename) {
            this.customers
              .searchCustomer(value, null, null)
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe((result: any) => {
                this.CustomersList = result.customers;
              });
          }
        });
    } else {
      this.newCustomer.valueChanges
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((value: any) => {
          if (!value || !value.__typename) {
            this.customers
              .searchCustomerByUserSeller(
                value,
                parseInt(this.userSeller!),
                null,
                null,
              )
              .pipe(takeUntilDestroyed(this.destroyRef))
              .subscribe((result: any) => {
                this.CustomersList = result.customers;
              });
          }
        });
    }
  }

  getAuthValues() {
    const company = this.cookieAuthService.getCompanyObject;
    this.companyId = company!.Id_company!.toString();
    this.user = this.cookieAuthService.getUserId!;
    this.rol = this.cookieAuthService.getRolId!;
    this.userSeller = this.cookieAuthService.getUserSellerId!;
  }

  setValuesByEnviroment() {
    while (this.rowsArr.length) this.rowsArr.removeAt(0);
    const seeded = this.fb.group({
      article: ['', Validators.required],
      quantity: [1, [Validators.required, Validators.min(0.001)]],
      price: [1, [Validators.required, Validators.min(0.001)]],
      discount: [0, Validators.required],
      subtotal: [1, Validators.required],
      warehouse: ['', Validators.required],
      unit: [''],
      customFactor: [1],
      quantityInBaseUnit: [1],
      isFactorEditable: [false],
    });
    this.rowsArr.push(seeded);
    const index = this.rowsArr.length - 1;
    this.filteredArticles[index] = [];
    this.subscribeArticleValueChangesForRow(index);
    this.showDevelopWarning = true;
  }

  addNewRow() {
    if (this.registerForm.invalid === true) {
      return;
    }

    const newRow = this.fb.group({
      article: ['', Validators.required],
      quantity: [1, [Validators.required, Validators.min(0.001)]],
      price: [1, [Validators.required, Validators.min(0.001)]],
      discount: [0, Validators.required],
      subtotal: [{ value: 0, disabled: false }, Validators.required],
      warehouse: ['', Validators.required],
      unit: [''],
      customFactor: [1],
      quantityInBaseUnit: [1],
      isFactorEditable: [false],
    });

    this.rowsArr.push(newRow);
    const index = this.rowsArr.length - 1;
    this.filteredArticles[index] = [];

    this.subscribeArticleValueChangesForRow(index);
    this.calculation();
  }

  private subscribeArticleValueChangesForRow(index: number) {
    const control = this.rowsArr.at(index).get('article');
    if (!control) return;

    control.valueChanges
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        filter((v: any) => typeof v === 'string' && v.trim().length > 0),
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((value: string) =>
          this.article.searchArticle(
            value,
            parseInt(this.currentWarehouse.toString()),
            null,
            null,
          ),
        ),
      )
      .subscribe((result: any) => {
        this.filteredArticles[index] = result?.articles || [];
      });

    // Subscribe to quantity changes
    const quantityControl = this.rowsArr.at(index).get('quantity');
    if (quantityControl) {
      quantityControl.valueChanges
        .pipe(takeUntilDestroyed(this.destroyRef), debounceTime(300))
        .subscribe(() => {
          this.onUnitOrQuantityChange(index, 'quantity');
        });
    }

    // Subscribe to unit changes
    const unitControl = this.rowsArr.at(index).get('unit');
    if (unitControl) {
      unitControl.valueChanges
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          this.onUnitOrQuantityChange(index, 'unit');
        });
    }
  }

  updateCurrentWareouse(id: number) {
    this.currentWarehouse = id;
  }

  deleteRow(rowIndex: number) {
    if (this.rowsArr.length > 1) {
      this.rowsArr.removeAt(rowIndex);
      this.filteredArticles.splice(rowIndex, 1);
    } else if (this.rowsArr.length === 1) {
      this.alertsService.showWarningAlert('You should not remove the last row');
    }
    this.calculation();
  }

  onArticleSelected(event: MatAutocompleteSelectedEvent, index: number) {
    const article: IArticles = event.option.value;
    const row = this.rowsArr.at(index);

    // Inicializar con la unidad base del artículo
    const baseUnitId = article.unit?.id_unit || '';
    const initialQuantity = row.get('quantity')?.value || 1;

    row.patchValue(
      {
        article,
        price: row.get('price')?.value,
        unit: baseUnitId,
        customFactor: 1,
        quantityInBaseUnit: initialQuantity, // Start with base unit assumption
        isFactorEditable: false,
      },
      { emitEvent: false }, // Don't emit to avoid triggering listeners
    );

    // Trigger unit calculation after patch to ensure correct quantityInBaseUnit
    this.onUnitOrQuantityChange(index, 'unit');
    this.calculation();
  }

  validRegister() {
    if (this.registerForm.invalid === true) {
      this.alertsService.showErrorAlert(
        'Please, fill in all the required fields!',
      );
      this.spinnerService.hide();
      return false;
    } else if (this.rowsArr.length > 11) {
      this.alertsService.showErrorAlert(
        'The quotation cannot have more than 11 items, please delete',
      );
      this.spinnerService.hide();
      return false;
    } else if (
      this.articleValidationsService.checkDuplicateArticles(this.rowsArr)
    ) {
      this.alertsService.showErrorAlert(
        'You cannot add the same item more than once on the same invoice',
      );
      this.spinnerService.hide();
      return false;
    } else {
      return true;
    }
  }

  validCustomer(variables: IQuotation) {
    if (!variables!.cliente?.id_cliente) {
      this.alertsService.showErrorAlert('This customer does not exist');
      this.spinnerService.hide();
      return false;
    } else {
      return true;
    }
  }

  validArticle(variables: IQuotation) {
    if (!variables!.venta[0]?.codigo[0]) {
      this.alertsService.showErrorAlert('This article does not exist');
      this.spinnerService.hide();
      return false;
    } else {
      return true;
    }
  }

  register() {
    this.spinnerService.show();
    let validResgister = this.validRegister();
    if (validResgister) {
      this.calculation();
      const variables = this.registerSalesService.setQuotationData(
        this.registerForm,
        this.rowsArr,
        this.newCustomer,
      );
      let validCustomer = this.validCustomer(variables!);
      let validArticle = this.validArticle(variables!);
      if (validCustomer && validArticle) {
        this.quotation
          .createQuotation(
            variables!.tax,
            variables!.cliente.id_cliente,
            variables!.venta[0].codigo,
            variables!.venta[0].cantidad,
            variables!.venta[0].precio,
            variables!.venta[0].descuento,
            variables!.venta[0].subtotal,
            variables!.venta[0].total,
            variables!.venta[0].id_almacen,
            variables!.venta[0].id_sale_unit,
            variables!.venta[0].quantity_in_base_unit,
            variables!.createdAt,
            variables!.dueDate,
            variables!.seller!.id_seller,
            variables!.tax_incl!,
            parseInt(this.user!),
            this.registerForm.get('positive_balance')?.value,
            this.registerForm.get('observations')?.value,
          )
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
            next: (result) => {
              if (result) {
                this.spinnerService.hide();
                this.alertsService
                  .showSuccessfullAlert('Quotation created successfully!')
                  .then((result) => {
                    if (result.isConfirmed) {
                      this.closeDialog();
                    }
                  });
              } else {
                this.spinnerService.hide();
                this.alertsService.showErrorAlert(
                  'Quotation has not been created',
                );
              }
            },
            error: (error) => {
              this.spinnerService.hide();
              const message =
                error?.graphQLErrors?.[0]?.message ||
                error?.message ||
                'Error al crear la cotización';
              this.alertsService.showErrorAlert(message);
            },
          });
      }
    }
  }

  calculation() {
    let priceCal;
    let quantityCal;
    let discountCal;
    let taxCal;
    let subsubtotal;

    for (let i = 0; i < this.rowsArr.length; i++) {
      if (this.registerForm.get('tax_incl')?.value === false) {
        if (this.rowsArr.value[i].article.tax[0].value === 0) {
          taxCal = this.registerForm.value.tax;
        } else {
          taxCal = this.rowsArr.value[i].article.tax[0].value;
        }
      } else {
        taxCal = 0;
      }
      priceCal = this.rowsArr.value[i].price;
      quantityCal = this.rowsArr.value[i].quantity;
      discountCal = this.rowsArr.value[i].discount;
      if (taxCal) {
        if (discountCal != 0) {
          subsubtotal = quantityCal * priceCal;
          discountCal = (discountCal / 100) * subsubtotal;
          subsubtotal = subsubtotal - discountCal;
          if (this.rowsArr.value[i].article.tax[0].value === 0) {
            taxCal = (taxCal / 100) * subsubtotal;
          } else {
            taxCal = taxCal * subsubtotal;
          }
          this.rowsArr.value[i].subtotal = subsubtotal + taxCal;
        } else {
          subsubtotal = quantityCal * priceCal;
          if (this.rowsArr.value[i].article.tax[0].value === 0) {
            taxCal = (taxCal / 100) * subsubtotal;
          } else {
            taxCal = taxCal * subsubtotal;
          }
          this.rowsArr.value[i].subtotal = priceCal * quantityCal + taxCal;
        }
      } else if (discountCal != 0) {
        discountCal = (discountCal / 100) * (priceCal * quantityCal);
        this.rowsArr.value[i].subtotal = priceCal * quantityCal - discountCal;
      } else {
        this.rowsArr.value[i].subtotal = priceCal * quantityCal;
      }
    }
    this.totalQuot = 0;
    for (let i = 0; i < this.rowsArr.length; i++) {
      this.totalQuot = this.totalQuot + this.rowsArr.value[i].subtotal;
    }
  }

  displayFnArticle(article: any) {
    return article
      ? `${article.descripcion} - (${article.tax?.[0]?.value ?? ''})`
      : '';
  }

  displayFnCustomer(customer: any) {
    return customer && customer ? customer.nombre : '';
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  textValid(text: string, index?: number) {
    return (
      this.registerForm.get(text)?.invalid &&
      this.registerForm.get(text)?.touched
    );
  }

  arrayvalid(text: string) {
    return this.rowsArr.get(text)?.invalid && this.rowsArr.get(text)?.touched;
  }

  getSeller(customer: any) {
    const seller = customer.userSeller.seller;
    this.registerForm.get('seller')?.setValue(seller);
  }

  taxValid(tax: boolean) {
    return tax === true ? true : false;
  }

  compareSeller(item1: any, item2: any) {
    if (item1 === null || item2 === null) {
      return false;
    }
    return item1.id_seller === item2.id_seller;
  }

  setPositiveBalance(customer: ICustomer) {
    const positive_balance = customer.positive_balance;
    this.registerForm.get('positive_balance')?.setValue(positive_balance);
  }

  getAvailableUnitsForSale(article: IArticles): any[] {
    if (!article) return [];

    const units: any[] = [];

    if (article.unit) {
      units.push({
        id_unit: article.unit.id_unit,
        description: article.unit.description,
        id_second: article.unit.id_second,
        isBase: true,
      });
    }

    // id_packaging_unit is an Int and unit.id_unit an ID (string), so both
    // sides must be coerced before comparing. article.id_unit is not exposed
    // by the Articulos type, hence the nested unit.
    if (
      article.packagingUnit &&
      Number(article.id_packaging_unit) !== Number(article.unit?.id_unit)
    ) {
      units.push({
        id_unit: article.packagingUnit.id_unit,
        description: article.packagingUnit.description,
        id_second: article.packagingUnit.id_second,
        isPackaging: true,
      });
    }

    return units;
  }

  async onUnitOrQuantityChange(
    index: number,
    changedField: 'unit' | 'quantity',
  ) {
    const row = this.rowsArr.at(index);
    const article: IArticles = row.get('article')?.value;
    const quantity = parseFloat(row.get('quantity')?.value) || 1;
    const selectedUnit = parseInt(row.get('unit')?.value);

    if (!article || !article.unit?.id_unit) {
      return;
    }

    const baseUnit = Number(article.unit.id_unit);
    let factorToUse = parseFloat(row.get('customFactor')?.value) || 1;
    let shouldUpdateFactor = false;
    let isEditable = false;

    // ONLY calculate new factor when the unit changes
    if (changedField === 'unit') {
      shouldUpdateFactor = true;

      // CASE 1: Base unit
      if (selectedUnit === baseUnit) {
        factorToUse = 1;
        isEditable = false;
      }
      // CASE 2: Packaging unit of the article
      else if (
        article.id_packaging_unit &&
        selectedUnit === article.id_packaging_unit
      ) {
        factorToUse = article.packaging_unit_factor || 1;
        isEditable = false;
      }
      // CASE 3: Other unit - look for conversion in DB
      else {
        try {
          const factor = await this.unitConversionService
            .getConversionFactor(selectedUnit, baseUnit)
            .toPromise();

          if (factor !== null && factor !== undefined) {
            factorToUse = factor;
            isEditable = false;
          } else {
            factorToUse = 1;
            isEditable = true;
          }
        } catch (error) {
          console.warn('Error looking for conversion:', error);
          factorToUse = 1;
          isEditable = true;
        }
      }
    }

    // Calculate quantity in base unit
    const convertedQuantity = quantity * factorToUse;

    // Update form
    if (shouldUpdateFactor) {
      row.patchValue(
        {
          quantityInBaseUnit: convertedQuantity,
          customFactor: factorToUse,
          isFactorEditable: isEditable,
        },
        { emitEvent: false },
      );
    } else {
      row.patchValue(
        {
          quantityInBaseUnit: convertedQuantity,
        },
        { emitEvent: false },
      );
    }

    // Recalculate totalss
    this.calculation();
  }
}
